import React from "react";
import CategoryPage from "./CategoryPage";

export default function CctvPage() {
  return (
    <CategoryPage
      categoryMatch="cctv"
      title="CCTV"
      subtitle="Security cameras and surveillance systems for homes, businesses, and industry."
      searchPlaceholder="Search CCTV..."
    />
  );
}